import React, {useEffect, useState} from "react";
import "./PeykDetail.scss";
import {PackManHederBack} from "../../PackMan/PackManHederBack/PackManHederBack";
import {useHistory, useParams} from "react-router-dom";
import {
    checkCode_api,
    courierOrderDetail_api,
    courierOrderRequestDeliveryCode_api,
    courierOrderUpdate_api
} from "../PeykService";
import moment from "moment-jalaali";
import {ConvertTMonthName} from "../../../Services";
import Expand from "react-expand-animated";
import toaster from "toasted-notes";


function Success(props) {
    return(
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function PeykDetail() {

    const { id } = useParams();
    const history = useHistory()

    const [order,set_order] = useState({})
    const [posState,set_posState] = useState(false)
    const [attribExpand ,set_attribExpand] = useState(false);
    const [code ,set_code] = useState("");
    const [sCode ,set_sCode] = useState(null);
    const [sCodeLadda ,set_sCodeLadda] = useState(null);

    useEffect(()=>{
        getDetail();
    },[])


    const ConvertToJalaliSplited = (date) =>{
        if(date){
            let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
            let year = moment.utc(date.split('+')[0]).format('jYYYY');
            let day = moment.utc(date.split('+')[0]) .format('jDD');
            let hh = moment.utc(date.split('+')[0]).format('HH');
            let mm = moment.utc(date.split('+')[0]).format('mm');
            return {month,year,day,hh,mm}
        }
    }

    const ConvertToJalaliSplitedString = (date) =>{
        if(date){
            let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
            let year = moment.utc(date.split('+')[0]).format('jYYYY');
            let day = moment.utc(date.split('+')[0]).format('jDD');
            let hh = moment.utc(date.split('+')[0]).format('HH');
            let mm = moment.utc(date.split('+')[0]).format('mm');
            return day+" "+month+""+year+" - "+hh+":"+mm
        }else {
            return "-/-/-  -:-"
        }
    }

    const getDetail = async () =>{
        try{
            const response = await courierOrderDetail_api(id);
            console.log("detail : ",response.data);
            // response.data['pay_status'] = 1
            set_order(response.data)
        }catch (e) {
            console.log(e);
        }
    }



    function numberWithCommas  (x) {
        if (x === 0) {
            return 0
        }
        if(x){
            return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
        }
        return "-"
    }


    const sendCode = async ()=>{
        set_sCodeLadda(true)
        try{
            const check = await courierOrderRequestDeliveryCode_api(order.uid);
            set_sCode(check.data.delivery_code)
            toaster.notify(({ onClose }) => (<Success message={"کد برای مشتری ارسال شد"}/>), {duration: 2000});
            set_sCodeLadda(false)
        }catch (e) {
            console.log(e)
            toaster.notify(({ onClose }) => (<Error message={"ارسال نشد"}/>), {duration: 2000});
            set_sCodeLadda(false)
        }
    }


    const delivery = async ()=>{
        if(order.status===25){
            toaster.notify(({onClose}) => (<Success message={"این سفارش تحویل شده است"}/>), {duration: 2000});
            return
        }
        // if(!sCode) {
        //         toaster.notify(({onClose}) => (<Error message={"دکمه ارسال کد را بزنید"}/>), {duration: 2000});
        //         return ;
        // }

        if(!code) {
            toaster.notify(({onClose}) => (<Error message={"کد را وارد نمایید"}/>), {duration: 2000});
            return ;
        }


            //check client code

            console.log("code : ", code)




        try{
            const  ret = await  checkCode_api(order.uid,code);
            try {
                const deli = await courierOrderUpdate_api(order.uid);
                console.log("deli : ", deli)
                toaster.notify(({onClose}) => (
                    <Success message={"سفارش با موفقیت تحویل داده شده"}/>), {duration: 2000});
                set_order({...order, status: 25})
            } catch (e) {
                console.log(e)
            }
        }catch (e) {
                toaster.notify(({onClose}) => (<Error message={"کد ارسالی صحیح نمی باشد"}/>), {duration: 2000});
                return ;
        }

    }

    const statusBtn = (st) =>{
        if(st===25){
            return "تحویل شده"
        }else {
            return "تحویل دادن"
        }
    }

    return(
        <div className="peyk-detail-container">
            <PackManHederBack title={"جزییات سفارش"}/>
            {order ?<div>
                <div className="client-row-ct">
                    <div className="client-code-ct">
                        <input
                            onChange={(e)=>{
                                set_code(e.target.value)
                            }}
                            value={code}
                            type="text" name="" id="" placeholder="کد سفارش مشتری"/>
                            <span className="sendCode-btn">
                                {!sCodeLadda?
                                <span onClick={()=>{
                                sendCode()
                                }
                                }>ارسال کد</span>:
                                <i className="fa fa-spinner fa-spin"></i>
                                }
                            </span>
                    </div>
                    <div className="client-info-ct">
                        <span className="code">{order.uid}</span>
                        {order.user?<span className="name">{order.user.first_name+" "+order.user.last_name}</span>:null}
                    </div>
                </div>

                <div className="order-info-ct">
                    <div className="order-info-item">
                        <span className="value-price" style={{direction: "rtl"}}>   {order.amount}  تومان   </span>
                        <span className="label-price">مبلغ فاکتور</span>
                    </div>

                    <div className="order-info-item">
                        <span className="value">{ConvertToJalaliSplitedString(order.accept_courier_at)}</span>
                        <span  className="label">زمان تحویل به پیک</span>
                    </div>
                    <div className="order-info-item">
                        <span className="value">{ConvertToJalaliSplitedString(order.delivery_due)}</span>
                        <span  className="label">زمان سررسید تحویل</span>
                    </div>

                    <div className="address">
                        <span className="label">آدرس : </span>
                        <span className="value">{order.address && order.address.address}</span>
                    </div>
                </div>

                <div className="order-payment-ct">

                    <div className="order-payment-item">
                        <span className={order.pay_status!==1?"order-status-suc":"order-status-pend"} >
                            {order.pay_status!==1?"پرداخت شده":"پرداخت نشده"}
                        </span>
                        <span className="order-status-label"> وضعیت پرداخت   : </span>
                    </div>

                    {order.pay_status===1?    <div>
                        <div className="order-payment-item">
                            <div className="payment-type-ct">
                                <input type="checkbox" name="" id="" onClick={()=>{
                                    set_posState(!posState)
                                }}/>
                                <span className="order-status-label">پرداخت با پوز</span>
                            </div>
                            <span className="payment-type-label" style={{marginRight:50}}>در محل</span>
                            <span className="order-status-label">نوع پرداخت : </span>
                        </div>

                        {posState?<div className="order-payment-item-center">
                            <input type="text" name="" id="" placeholder="شماره تراکنش"/>
                        </div>:null}
                    </div>:null}


                </div>

                <div className="sub-factor-title" onClick={()=>{
                    set_attribExpand(!attribExpand)
                }}>
                    <span>ریز اقلام</span>
                    <i className="fa fa-angle-down"></i>
                </div>

                <div className="factor-sub-items">
                    <Expand open={attribExpand}>
                        <div className="factor-table" style={{paddingBottom:120,margin:24}}>
                            <table>
                                <thead>
                                <tr>
                                    <th className="product-table-head">جمع کل</th>
                                    {/*<th className="product-table-head">تخفیف</th>*/}
                                    <th className="product-table-head">تعداد</th>
                                    <th className="product-table-head product-table-head-name">نام کالا</th>
                                    <th className="product-table-head product-table-head-name">تصویر</th>
                                </tr>
                                </thead>
                                <tbody>
                                {order && order.items  && order.items.map(product => {
                                    return (
                                        <tr key={product.uid}>
                                            <td className="product-price">{numberWithCommas(product.amount)}</td>
                                            {/*<td className="product-count">{numberWithCommas(product.per_discount)}</td>*/}
                                            <td className="product-count">{product.quantity}</td>
                                            <td className="product-name">{product.product.name}</td>
                                            <td className="product-name">
                                                {product.product?<img src={product.product && product.product.image ? product.product.image : "/other/skeleton/product.jpg"} alt=""/>:null}
                                            </td>
                                        </tr>
                                    )
                                })
                                }
                                </tbody>
                            </table>

                            <div className="factor-table-total-row customer_discount-row">
                                <div className="factor-table-total--price customer_discount-val">
                                    <span>تومان</span>
                                    {<span>0</span>}
                                </div>
                                <span className="customer_discount"> : تخفیف  </span>
                            </div>

                            <div className="factor-table-total-row">
                                <div className="factor-table-total--price">
                                    <span>تومان</span>
                                    {order.amount ? <span>{numberWithCommas(order.amount)}</span> : null}
                                </div>
                                <span> : جمع کل  </span>
                            </div>
                        </div>
                    </Expand>
                </div>

                <div className="deliver-btn-ct">
                    <div className={order.status!==25?"notDeliver-btn":"deliver-btn"}  onClick={()=>{
                        delivery()
                    }}>
                        <span>{statusBtn(order.status)}</span>
                    </div>
                </div>
            </div>:null}
        </div>
    )
}

export {PeykDetail}
